<script>
    import MobileNavbar from '../../reusableitems/mobileNavbar.svelte';
    import Artscreen2 from './artscreen2.svelte';
    import Vfx from './vfx.svelte';
    import Image from './ImageScreen.svelte';
    import Virtualfashion from './virtualfashion.svelte';
    import SoundArtist from './SoundArtist.svelte';
    import Character from './character.svelte';
    import Artistmusicians from './artistmusicians.svelte';

    let scrollPointers = {scrollValue: 0};
    let updatedValue = 0;
    let paginationBox;
    let paginationBox1;
    let nextPages = false;
    const circle = [];
    let arrow;
    let image2;
    let changeCircleColor = false;

    // Top in vw for everycondition
    // Formula Used for point movement in increasing condition
    // ((highestValue - LowestValue) * (updatedValue - lowestUpdatedCondition) + LowesetValue)
    // Formula Used for point movement in decreasing condition then divide by 2.16355 to convert in vh
    // (highestValue -(highestValue - LowestValue) * (updatedValue - lowestUpdatedCondition))
    $: if (updatedValue > 0 && updatedValue <= 0.2) {
        paginationBox.style.display = 'none';
    } else if (updatedValue > 0.2 && updatedValue <= 1) {
        paginationBox.style.display = 'block';
        paginationBox.style.opacity = updatedValue;
        nextPages = false;
    } else if (updatedValue > 1 && updatedValue <= 1.8) {
        paginationBox.style.opacity = 1 - (updatedValue - 0.8);
        circle[0].style.top = '0vw';
        circle[1].style.top = '4.2059vw';
        circle[2].style.top = '7.944vw';
        image2.style.top = 'max(100vh,216vw)';
    } else if (updatedValue > 1.8 && updatedValue <= 2.0 && nextPages) {
        paginationBox.style.opacity = 1;
        paginationBox.style.transitionDelay = '0.8s';
        circle[0].style.top = '3.27vw';
        circle[1].style.top = '0vw';
        circle[2].style.top = '7.944vw';
    } else if (updatedValue > 2.0 && updatedValue <= 3) {
        paginationBox.style.opacity = 1;
        circle[0].style.top = 3.738 * (updatedValue - 2) + 3.271 + 'vw';
        circle[2].style.top = 7.477 - 3.739 * (updatedValue - 2) + 'vw';
        circle[1].style.top = '0vw';
        circle[3].style.top = '11.215vw';
        paginationBox1.style.top ='0vh';
    } else if (updatedValue > 3 && updatedValue <= 4) {
        paginationBox1.style.top =
            (79.439 * (updatedValue - 3)) / 2.16355 + 'vh';
        circle[0].style.top = 3.739 * (updatedValue - 3) + 7.009 + 'vw';
        circle[3].style.top = 11.215 - 3.738 * (updatedValue - 3) + 'vw';
        circle[2].style.top = '3.738vw';
        circle[4].style.top = '14.953vw';
        changeCircleColor = false;
    } else if (updatedValue > 4 && updatedValue <= 4.5) {
        circle[3].style.top = '7.477vw';
        circle[5].style.top = '19.159vw';
        circle[0].style.top = 3.738 * (updatedValue - 4) + 10.748 + 'vw';
        circle[4].style.top = 14.953 - 3.738 * (updatedValue - 4) + 'vw';
        arrow.style.bottom = '0vw';
        arrow.style.scale = 1;
        changeCircleColor = false;
    } else if (updatedValue > 4.5 && updatedValue <= 5) {
        circle[3].style.top = '7.477vw';
        circle[5].style.top = '19.159vw';
        circle[0].style.top = 3.738 * (updatedValue - 4) + 10.748 + 'vw';
        circle[4].style.top = 14.953 - 3.738 * (updatedValue - 4) + 'vw';
        arrow.style.scale = 1;
        arrow.style.bottom = '0vw';
        changeCircleColor = true;
    } else if (updatedValue > 5 && updatedValue <= 5.5) {
        paginationBox1.style.top =
            (79.439 - 65.421 * (updatedValue - 5)) / 2.16355 + 'vh';
        circle[4].style.top = '11.215vw';
        circle[7].style.top = 9.346 * (updatedValue - 5) + 'vw';
        circle[0].style.top = 3.738 * (updatedValue - 5) + 14.486 + 'vw';
        circle[5].style.top = 18.692 - 3.739 * (updatedValue - 5) + 'vw';
        arrow.style.bottom = 24.766 * (updatedValue - 5) + 'vw';
        arrow.style.scale = 1 - (updatedValue - 5);
        arrow.style.rotate = '0deg';
        changeCircleColor = true;
    } else if (updatedValue > 5.5 && updatedValue <= 6) {
        circle[4].style.top = '11.215vw';
        paginationBox1.style.top =
            (79.439 - 65.421 * (updatedValue - 5)) / 2.16355 + 'vh';
        circle[7].style.top = 9.346 * (updatedValue - 5) + 'vw';
        circle[0].style.top = 3.738 * (updatedValue - 5) + 14.486 + 'vw';
        circle[5].style.top = 18.692 - 3.739 * (updatedValue - 5) + 'vw';
        arrow.style.bottom = 24.766 * (updatedValue - 5) + 'vw';
        arrow.style.scale = updatedValue - 5;
        arrow.style.rotate = '180deg';
        changeCircleColor = false;
    }
</script>

<section>
    <div class="navbar">
        <MobileNavbar />
    </div>
    <div>
        <Artistmusicians bind:scrollPointers bind:updatedValue />
    </div>
    <div>
        <Artscreen2 bind:scrollPointers bind:updatedValue />
    </div>
    <div>
        <Image
            bind:scrollPointers
            bind:updatedValue
            bind:nextPages
            bind:image2
        />
    </div>
    {#if nextPages}
        <div>
            <Vfx bind:scrollPointers bind:updatedValue />
        </div>
        <div>
            <Character bind:scrollPointers bind:updatedValue />
        </div>
        <div>
            <Virtualfashion bind:scrollPointers bind:updatedValue />
        </div>
        <div>
            <SoundArtist />
        </div>
    {/if}
    <div class="pagination-box-wrapper" bind:this={paginationBox}>
        <div class="pagination-box" bind:this={paginationBox1}>
            <div class="circle-wrapper" bind:this={circle[7]}>
                {#each Array(6) as _, i}
                    {#if i === 0}
                        <div
                            class="black-circle-wrapper circle{i}"
                            style=" background-color: {changeCircleColor ?
                                'white' :
                                ''};"
                            bind:this={circle[i]}
                        />
                    {:else}
                        <div
                            class="white-circle-wrapper circle{i}"
                            style="border-color: {changeCircleColor ?
                                'white' :
                                ''};"
                            bind:this={circle[i]}
                        />
                    {/if}
                {/each}
            </div>
            <div
                class="arrow-wrapper {changeCircleColor ? 'change-color' : ''}"
                bind:this={arrow}
            >
                <svg
                    width="100%"
                    height="100%"
                    viewBox="0 0 12 23"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M5.46967 22.5303C5.76256 22.8232 6.23744 22.8232 6.53033 
    22.5303L11.3033 17.7574C11.5962 17.4645 11.5962 16.9896 11.3033 
    16.6967C11.0104 16.4038 10.5355 16.4038 10.2426 16.6967L6 20.9393L1.75736 
    16.6967C1.46447 16.4038 0.989592 16.4038 0.696698 16.6967C0.403805 16.9896 
    0.403805 17.4645 0.696698 17.7574L5.46967 22.5303ZM5.25 -3.27833e-08L5.25 
    22L6.75 22L6.75 3.27833e-08L5.25 -3.27833e-08Z"
                        fill="black"
                    />
                </svg>
            </div>
        </div>
    </div>
</section>

<style>
    .pagination-box-wrapper {
        position: fixed;
        z-index: 10;
        top: 30.45vh;
        right: 4.673vw;
        opacity: 0;
    }
    .pagination-box {
        position: relative;
        width: 2.336vw;
        height: 29.907vw;
    }
    .black-circle-wrapper {
        position: absolute;
        width: 2.336vw;
        height: 2.336vw;
        background-color: black;
        border-radius: 50%;
    }
    .circle-wrapper {
        position: relative;
    }
    .circle0 {
        top: 0vw;
    }
    .circle1 {
        top: 4.206vw;
    }
    .circle2 {
        top: 7.944vw;
    }
    .circle3 {
        top: 11.682vw;
    }
    .circle4 {
        top: 15.421vw;
    }
    .circle5 {
        top: 19.159vw;
    }
    .white-circle-wrapper {
        position: absolute;
        left: 0;
        right: 0;
        margin: auto;
        width: 1.402vw;
        height: 1.402vw;
        box-sizing: border-box;
        border: 0.234vw solid;
        border-color: black;
        border-radius: 50%;
    }
    .arrow-wrapper {
        position: absolute;
        bottom: 0;
        width: 2.336vw;
        height: 5.14vw;
    }
    .change-color path {
        fill: white;
    }
    section {
        overflow: hidden;
    }
    .navbar {
        position: fixed;
        width: 100%;
        z-index: 100;
    }
</style>
